import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['amount']
  static values = { available: String }

  useAvailable(event) {
    event.preventDefault()
    this.amountTarget.value = this.availableValue
    this.amountTarget.focus()
  }
}
